import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '@bonusly/design-system';

import { Bonus } from '../../../../../types/bonus';
import { formatReceiverNames } from './utils';

interface InviteDescriptionProps {
	bonus: Bonus;
}

const InviteDescription: FC<InviteDescriptionProps> = ({ bonus }) => {
	const { t } = useTranslation(['recognition']);

	if (!bonus.receivers || bonus.receivers.length === 0) {
		return <Text>{t('invite_others_modal.fallback_description')}</Text>;
	}

	const receiverNames = bonus.receivers.map((receiver) => receiver.display_name);
	const formattedNames = formatReceiverNames(receiverNames, t);

	return <Text>{formattedNames ? t('invite_others_modal.description', { name: formattedNames }) : t('invite_others_modal.fallback_description')}</Text>;
};

export default InviteDescription;
